export default __webpack_public_path__ + "static/media/logoD.5d2dbd1a.png";